import { useEffect } from 'react';

// Keep in sync with the breakpoint in libs/ui-ds-base/src/lib/modal/modal.tsx.
const DESKTOP_MEDIA_QUERY = '(min-width: 768px)';

/**
 * Mobile: when the on-screen keyboard opens, Vaul shrinks the drawer to the visual viewport, which
 * can leave the focused input under the sticky footer. Scroll the modal body so the input sits at
 * its top, leaving room below for the autocomplete suggestions.
 */
export const scrollFocusedInputToTop = () => {
  const input = document.activeElement;
  if (!(input instanceof HTMLInputElement)) return;
  const scroller = input.closest<HTMLElement>('[data-vaul-no-drag]');
  if (!scroller) return;
  const offset = input.getBoundingClientRect().top - scroller.getBoundingClientRect().top;
  scroller.scrollTop += offset - 16;
};

export const useKeepFocusedInputVisible = (enabled: boolean) => {
  useEffect(() => {
    const viewport = typeof window !== 'undefined' ? window.visualViewport : null;
    if (!enabled || !viewport) return;
    const onResize = () => {
      // visualViewport also resizes on desktop window resize/zoom: only act on the mobile drawer,
      // using the same breakpoint as the DS Modal (Dialog from 768px, Vaul drawer below).
      if (window.matchMedia(DESKTOP_MEDIA_QUERY).matches) return;
      // Two frames: let Vaul apply the new drawer height first (it listens to the same resize).
      requestAnimationFrame(() => requestAnimationFrame(scrollFocusedInputToTop));
    };
    viewport.addEventListener('resize', onResize);
    return () => viewport.removeEventListener('resize', onResize);
  }, [enabled]);
};
